import axios from './index'
import authHeader from '../auth/authHeader'

export default {
  dailyActivityReport (data) {
    return axios.get(process.env.VUE_APP_API_URL + '/reports/daily-activity-report', { headers: authHeader(), params: data })
  },
  exportReport (data) {
    return axios.get(process.env.VUE_APP_API_URL + '/reports/daily-income-report/export', { headers: authHeader(), params: data })
  },
  commissionReport (data) {
    return axios.get(process.env.VUE_APP_API_URL + '/reports/commission-report', { headers: authHeader(), params: data })
  },
  overheadExpenseReport (data) {
    return axios.get(process.env.VUE_APP_API_URL + '/reports/daily-overhead-expenses-report', { headers: authHeader(), params: data })
  },
  dailyIncomeReport (data) {
    return axios.get(process.env.VUE_APP_API_URL + '/reports/daily-income-report', { headers: authHeader(), params: data })
  },
  dailyIncomeTreatmentReport (data) {
    return axios.get(process.env.VUE_APP_API_URL + '/reports/daily-income-report/services', { headers: authHeader(), params: data })
  }
}
